import React from 'react'
import { Card, Typography, Skeleton } from 'antd'
import Editor from '../../../../../../components/common/Editor/Editor'
import { useSelector } from 'react-redux'
import { rubricRefinementSelectors } from '../../../../../../store/selectors/rubricRefinement.selectors'
import { getCategoryById } from '../../../../../../store/apis/utils/selectors/question.api.selectors'
import { primaryColor } from '../../../../../../constants/styles'
import { isNumber } from 'lodash'
import { getColorByIndex } from '../../../../../../utils/colors.helper'
import { useParams } from 'react-router'
import { useVersionId } from '../../../../../../utils/parseURL.helper'
import { useFetchQuestionsQuery } from '../../../../../../store/apis/question.api'

const SubmissionCard = ({ isLoading: isLoadingProps }) => {
    const lastSubmissionItem = useSelector(rubricRefinementSelectors.lastSubmissionItem)
    const hoveredCategoryId = useSelector(rubricRefinementSelectors.hoveredCategoryId)
    const hasStarted = useSelector(rubricRefinementSelectors.hasStarted)
    const refinementProcess = useSelector(rubricRefinementSelectors.refinementProcess)

    const { token } = useParams()
    const versionId = useVersionId()
    const { data: questions, isFetching: isQuestionsFetching } = useFetchQuestionsQuery({ token, versionId })
    const isLoading = isLoadingProps || isQuestionsFetching

    // If we haven't started yet, don't render anything
    if (!hasStarted || !lastSubmissionItem) return null

    // If we're initializing, don't render anything
    if (refinementProcess?.status === 'Initializing') return null

    const getHighlightRanges = () => {
        const category = lastSubmissionItem?.categories.find(c => c.id == hoveredCategoryId)

        if (!hoveredCategoryId || !questions || !category?.explainability?.highlights) return []

        const categoryDetails = getCategoryById(questions, hoveredCategoryId)

        return category.explainability.highlights.map(highlight => ({
            start: highlight.start,
            end: highlight.end,
            opacity: highlight.importance,
            color: isNumber(categoryDetails?.colorId) ? getColorByIndex(categoryDetails.colorId).value : primaryColor,
        }))
    }

    return (
        <Card className='submission-card'>
            {isLoading ? (
                <Skeleton active paragraph={{ rows: 6 }} title={false} />
            ) : (
                <Editor
                    language='text'
                    readOnly={true}
                    value={lastSubmissionItem?.submission?.content}
                    showLineNumbers={false}
                    wrapLines
                    title={<Typography.Text type='secondary'>Submission</Typography.Text>}
                    wrapperStyles={{ height: '100%' }}
                    highlightRanges={getHighlightRanges()}
                    selectedPatterns={[]}
                />
            )}
        </Card>
    )
}

export default SubmissionCard
